import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

class ClubsDataService extends APIBaseFunctions {
  private cachedClubsDataSliceObj: APIDataSliceObj = {
    slicemode: 0,
    start: 0,
    limit: defaultAPILimit,
    page: 0,
    pagesize: 0,
    totalcount: 0
  }

  getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    const currentDataSliceObj = ClubsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedClubsDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      return http.get(`/klubbers?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '' + '&populate=*'))
    }

    return http.get(`/klubbers?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '' + '&populate=*'))
  }

  get (id: string) {
    return http.get(`/klubbers/${id}?populate=*`)
  }

  getByClubName (name: string) {
    return http.get(`/klubbers/?filters[klubber_klubnavn]=${name}`)
  }

  getBySlug (slug: string) {
    return http.get(`/klubbers/?klubber_slug=${slug}`)
  }

  getCount (extraCountParameter = '') {
    return http.get('/klubbers/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
  }

  create (data: any) {
    return http.post('/klubbers', data)
  }

  update (id: string, data: any) {
    return http.put(`/klubbers/${id}`, data)
  }

  delete (id: string) {
    return http.delete(`/klubbers/${id}`)
  }

  deleteAll () {
    return http.delete('/klubbers')
  }

  findByClubStatus (status: boolean, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    let sortingOrderParameter = ''
    const currentDataSliceObj = ClubsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedClubsDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }

    return http.get(`/klubbers?filters[klubber_status]=${status}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
  }

  findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    let retVal
    let sortingOrderParameter = ''
    const currentDataSliceObj = ClubsDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedClubsDataSliceObj }, dataSliceObj)
    searchTerm = searchTerm.trim()

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }

    if (!isNaN(Number(searchTerm))) {
      // Handle post number in search term. In order to change back to handle telephone number in search term uncomment one line and comment out the other line
      if (ignoreStatus) {
        // retVal = http.get(`/klubbers?klubber_telefonnummer_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
        retVal = http.get(`/klubbers?bypost_id.bypost_postnummer_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      } else {
        // retVal = http.get(`/klubbers?klubber_status=${status}&klubber_telefonnummer_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
        retVal = http.get(`/klubbers?klubber_status=${status}&bypost_id.bypost_postnummer_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }
    } else if (searchTerm.indexOf('@') >= 0) {
      // Handle email address in search term
      if (ignoreStatus) {
        retVal = http.get(`/klubbers?klubber_email_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      } else {
        retVal = http.get(`/klubbers?klubber_status=${status}&klubber_email_contains=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }
    } else {
      // Do a search in names for the search term
      if (ignoreStatus) {
        retVal = http.get(`/klubbers?filters[$or][0][klubber_klubnavn][$contains]=${searchTerm}&filters[$or][1][klubber_klubbeskrivelse][$contains]=${searchTerm}&filters[$or][2][bypost_id][bypost_by][$contains]=${searchTerm}&filters[$or][3][klubber_vejnavn][$contains]=${searchTerm}&filters[$or][4][region_id][region_navn][$contains]=${searchTerm}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      } else {
        retVal = http.get(`/klubbers?klubber_status=${status}&filters[$or][0][klubber_klubnavn][$contains]=${searchTerm}&filters[$or][1][klubber_klubbeskrivelse][$contains]=${searchTerm}&filters[$or][2][bypost_id][bypost_by][$contains]=${searchTerm}&filters[$or][3][klubber_vejnavn][$contains]=${searchTerm}&filters[$or][4][region_id][region_navn][$contains]=${searchTerm}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }
    }

    return retVal
  }

  // Club tournament

  getClubberRaekke (clubId: string) {
    return http.get(`/klubber-raekkers?_where[_or][0][klubber.id]=${clubId}`)
  }

  getClubTournamentExtraPointRules (clubId: string) {
    return http.get(`/club-point-rules?_where[_or][0][klubber_id]=${clubId}`)
  }

  createClubTournamentExtraPointRule (data: any) {
    return http.post('/club-point-rules', data)
  }

  deleteClubTournamentExtraPointRule (id: string) {
    return http.delete(`/club-point-rules/${id}`)
  }

  updateClubTournamentExtraPointRule (id: string, data: any) {
    return http.put(`/club-point-rules/${id}`, data)
  }

  getMedlemsClubPoints (extraParameter = '') {
    // return http.get(`/medlems-klubber-points/${medlemId}`)
    return http.get('/medlems-klubber-points' + (extraParameter && ('?' + extraParameter)))
  }

  createMedlemsClubPoints (data: any) {
    return http.post('/medlems-klubber-points', data)
  }

  updateMedlemsClubPoints (id: string, data: any) {
    return http.put(`/medlems-klubber-points/${id}`, data)
  }

  getClubMatchChalker (extraParameter = '') {
    return http.get('/club-match-chalkers' + (extraParameter && ('?' + extraParameter)))
  }

  createClubMatchChalker (data: any) {
    return http.post('/club-match-chalkers', data)
  }
}

export default new ClubsDataService()
